import AppointmentsDoctorsListScreen from './AppointmentsDoctorsListScreen';

export default AppointmentsDoctorsListScreen;
